module.exports = __webpack_public_path__ + "static/img/1.e9fe908.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/entrance/1.png
// module id = KZvn
// module chunks = 1